// LUT-941: ToS + Privacy Policy update. Keep the version in sync with
// CURRENT_POLICY_VERSION in lutely-api (src/auth/policy.constants.ts).
export const POLICY_VERSION = "2026-09-02";

// When the updated policies take effect.
export const POLICY_EFFECTIVE_DATE = new Date("2026-09-02T00:00:00.000Z");

// The announcement banner auto-hides two weeks after launch.
export const POLICY_BANNER_HIDE_AFTER = new Date(
  POLICY_EFFECTIVE_DATE.getTime() + 14 * 24 * 60 * 60 * 1000,
);
